export default __webpack_public_path__ + "static/media/SummerBook_00.ef055914.png";